export const METHOD_LABELS: Record<string, string> = {
  card: 'Card',
  ach: 'ACH',
  zelle: 'Zelle',
  cash: 'Cash',
  check: 'Check',
  bhcs_cash: 'BHCS Cash',
};
